import React from "react";
import Button from "../common/Button";

interface CardProps {
  card: {
    id: string;
    isDefault: boolean;
    brand: string;
    last4: string;
  };
  payNow: (id: string) => void;
}

const CardRow: React.FC<CardProps> = ({ card, payNow }) => {
  return (
    <tr
      className={
        card.isDefault ? "payment-cards default-card" : "payment-cards"
      }
    >
      <td
        style={{ padding: "20px" }}
        className="d-flex justify-content-start align-items-center gap-2"
      >
        <input
          className="form-check"
          type="checkbox"
          checked={card.isDefault}
          id="cb-checkout"
          // disabled
        />
      </td>
      <td style={{ padding: "20px" }}>{card.brand}</td>
      <td style={{ padding: "20px" }}>xxxx-xxxx-xxxx-{card.last4}</td>
      <td style={{ padding: "20px" }} className="justify-content-end">
        <Button
          type="primary"
          label="Buy Now"
          ifClicked={() => {
            payNow(card.id);
          }}
        />
      </td>
    </tr>
  );
};

export default CardRow;
